/* Cart-only dismissal. The existing dialog host remains the owner of native
   modal state, scroll locking and focus return; populated cart logic is intact. */
(() => {
  if (customElements.get('cart-drawer-motion')) return;
  class CartDrawerMotion extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.host = this.closest('dialog-component');
      if (!this.dialog || !this.host) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.dialog.addEventListener('click', this.onClick, true);
      this.dialog.addEventListener('cancel', this.onCancel);
      this.dialog.addEventListener('close', this.onClosed);
      this.motion.addEventListener('change', this.onEnvironmentChange);
      window.addEventListener('resize', this.onEnvironmentChange);
      document.addEventListener('shopify:section:unload', this.onUnload);
    }
    disconnectedCallback() {
      this.finishClose();
      this.dialog?.removeEventListener('click', this.onClick, true);
      this.dialog?.removeEventListener('cancel', this.onCancel);
      this.dialog?.removeEventListener('close', this.onClosed);
      this.motion?.removeEventListener('change', this.onEnvironmentChange);
      window.removeEventListener('resize', this.onEnvironmentChange);
      document.removeEventListener('shopify:section:unload', this.onUnload);
    }
    onClick = (event) => {
      if (event.target.closest('dialog') !== this.dialog) return;
      if (event.target === this.dialog || event.target.closest('[data-dialog-close]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.requestClose();
      }
    };
    onCancel = (event) => { event.preventDefault(); this.requestClose(); };
    onClosed = () => { if (!this.dialog.open) this.clearMotion(); };
    onEnvironmentChange = () => { if (this.closing) this.finishClose(); };
    onUnload = (event) => { if (event.target.contains(this)) this.finishClose(); };
    requestClose() {
      if (!this.dialog.open || this.closing) return;
      if (this.motion.matches || !this.dialog.animate) { this.finishClose(); return; }
      this.closing = true;
      const current = getComputedStyle(this.dialog).transform;
      const offset = matchMedia('(max-width: 767px)').matches ? '100%' : 'calc(100% + 30px)';
      this.dialog.dataset.cartClosing = '';
      this.animation = this.dialog.animate(
        [{ transform: current }, { transform: `translateX(${offset})` }],
        { duration: 500, easing: 'cubic-bezier(.7, 0, .2, 1)', fill: 'both' }
      );
      this.animation.finished.then(() => this.finishClose(), () => {});
      // A suspended animation timeline must not leave a permanently locked cart.
      this.timer = setTimeout(() => this.finishClose(), 550);
    }
    clearMotion() {
      clearTimeout(this.timer);
      this.animation?.cancel();
      this.animation = null;
      this.closing = false;
      this.dialog?.removeAttribute('data-cart-closing');
    }
    finishClose() {
      this.clearMotion();
      if (this.dialog?.open) {
        if (typeof this.host?.close === 'function') this.host.close();
        else this.dialog.close();
      }
    }
  }
  customElements.define('cart-drawer-motion', CartDrawerMotion);
})();
